module.exports = __webpack_public_path__ + "img/summary-dispute-approved.51002a83.svg";